import { useEffect, useState } from 'react';
import AnimatedNumber from 'react-animated-number';
import Image from '../../../components/image/Image';
import LoaderBar from '../../../components/loader-bar/LoaderBar';
import { ContentTitle } from '../../../components/typography/Heading';
import { formatMoneyKr, formatNumber } from '../../../utils';
import styles from './live-data.module.less';
import { fetchData } from './live-data-ftf-actions';

const LiveDataFTF = () => {
    const [spleiserTotalt, setSpleiserTotalt] = useState();
    const [givereTotalt, setGivereTotalt] = useState();
    const [belopTotalt, setBelopTotalt] = useState();
    const [elementInList, setElementInList] = useState(0);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchNewData = () => {
        fetchData()
            .then((data) => {
                const totalt = data.values.find((v) => v[0] === 'givere_totalt');
                const innsamet = data.values.find((v) => v[0] === 'innsamlet_totalt');
                const spleiser = data.values.find((v) => v[0] === 'spleiser_totalt');
                setElementInList(0);
                setError(false);
                setGivereTotalt(totalt[1]);
                setBelopTotalt(innsamet[1]);
                setSpleiserTotalt(spleiser[1]);
            })
            .catch(() => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        setLoading(true);
        fetchNewData();
    }, []);

    useEffect(() => {
        const timer = setInterval(fetchNewData, 30 * 1000);
        return () => clearInterval(timer);
    }, []);

    if (error) {
        return null;
    }

    if (loading) {
        return <LoaderBar />;
    }

    return (
        <div className={styles.container}>
            <ContentTitle>Aktivitet</ContentTitle>
            <div className={styles.numberWrapper}>
                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image className={styles.icon} src={'/public/images/fund-as-gift/konfettifløyte.svg'} />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={spleiserTotalt?.[elementInList]}
                            formatValue={formatNumber}
                        />
                    </div>
                    <span className={styles.numberDescription}>spleiser totalt</span>
                </div>

                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image
                            className={styles.icon}
                            src={'/public/images/feature-illustrations/hånd-hjerte-blå-mørkere.svg'}
                        />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={givereTotalt?.[elementInList]}
                            formatValue={formatNumber}
                        />
                    </div>
                    <span className={styles.numberDescription}>givere totalt</span>
                </div>

                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image className={styles.icon} src={'/public/images/feature-illustrations/penger-vinger.svg'} />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={belopTotalt?.[elementInList]}
                            formatValue={formatMoneyKr}
                        />
                    </div>
                    <span className={styles.numberDescription}>innsamlet totalt</span>
                </div>
            </div>
        </div>
    );
};

export default LiveDataFTF;
